// Add ID to Contactformulier heading for anchor links and handle scroll offset
document.addEventListener('DOMContentLoaded', function() {
  const h3Elements = document.querySelectorAll('h3');
  let contactFormHeading = null;
  
  for (let i = 0; i < h3Elements.length; i++) {
    if (h3Elements[i].textContent.trim() === 'Contactformulier') {
      contactFormHeading = h3Elements[i];
      contactFormHeading.id = 'contactformulier';
      // Add scroll margin for better positioning
      contactFormHeading.style.scrollMarginTop = '100px';
      break;
    }
  }
  
  // Handle hash links with offset
  function handleHashScroll() {
    if (window.location.hash === '#contactformulier' && contactFormHeading) {
      const elementPosition = contactFormHeading.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - 100; // 100px offset
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }
  
  // Handle initial hash on page load
  if (window.location.hash === '#contactformulier') {
    setTimeout(handleHashScroll, 100);
  }
  
  // Handle hash changes (when clicking links)
  window.addEventListener('hashchange', handleHashScroll);
  
  // Also handle clicks on anchor links
  document.querySelectorAll('a[href="#contactformulier"]').forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      if (contactFormHeading) {
        const elementPosition = contactFormHeading.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - 100; // 100px offset
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
        // Update URL without triggering hashchange
        history.pushState(null, null, '#contactformulier');
      }
    });
  });
});

